export const register = {
  // Page header
  label: 'Join EachTeach',
  heading: '커뮤니티 등록',
  intro: 'EachTeach 커뮤니티에 참여하여 교육의 질을 함께 높여 나갑시다.',

  // Success state
  successTitle: '등록이 완료되었습니다!',
  successBody1: 'EachTeach 커뮤니티에 등록해 주셔서 감사합니다.',
  successBody2: '입력하신 이메일 주소로 상세 내용을 보내드립니다.',

  // Form labels
  form: {
    name: '이름',
    namePlaceholder: '홍길동',
    birthdate: '생년월일',
    email: '이메일 주소',
    emailPlaceholder: 'example@email.com',
    nationality: '국적',
    nationalityPlaceholder: '대한민국',
    organization: '단체명・소속 (선택)',
    organizationPlaceholder: '예: ◯◯어학원 (개인의 경우 공란 가능)',
    languages: '가르칠 수 있는 언어',
    languagesOtherPlaceholder: '기타 언어가 있으면 입력',
    selected: '선택 중',
    category: '구분',
    categorySelect: '선택해 주세요',
    consent:
      '단체명・소속을 EachTeach 소개 페이지에 게재하는 것에 동의합니다 (선택).',
    consentNote:
      '동의하신 경우에도 게재는 내용 확인 후 진행됩니다. 미동의 상태로도 등록하실 수 있습니다.',
    requiredMark: '*',
    submit: '등록하기',
    submitting: '전송 중...',
  },

  // Category options
  categories: {
    tutor: '개인 가정교사',
    aspiring: '개인 가정교사가 되고 싶은 사람',
    sla: 'SLA 분야 전문가',
  },

  // Language options
  languages: {
    japanese: '일본어',
    english: '영어',
    chineseMandarin: '중국어 (표준어)',
    chineseCantonese: '중국어 (광둥어)',
    korean: '한국어',
    spanish: '스페인어',
    french: '프랑스어',
    german: '독일어',
    portuguese: '포르투갈어',
    italian: '이탈리아어',
    russian: '러시아어',
    arabic: '아랍어',
    hindi: '힌디어',
    turkish: '터키어',
    other: '기타',
  },

  // Error / validation messages
  errors: {
    saveFailed: '등록 저장에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    submitFailed: '전송 중 오류가 발생했습니다. 다시 시도해 주세요.',
  },
};
